<template>
  <!--
    미인증 상태일 경우 - 보증기간 변경
  -->
  <v-row justify="center">
    <v-dialog v-model="unAuthDaysDialog" max-width="370px">
      <v-card>
        <v-card-title>보증기간 변경</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mb-0 pb-7">
          <p class="font-weight-bold mt-7 body-2 black--text mb-2">보증기간 수정시 참고해주세요.</p>
          <p class="mb-0 font-weight-bold caption">보증기간은 고객에게 민감한 사항이므로</p>
          <p class="mb-0 font-weight-bold caption">고객이 인증받은 경우 협의 후 사용하시길 권장합니다.</p>
          <v-select
            v-model="payload.cert_duration_type"
            :items="authDateKind"
            dense
            hide-details
            height="50px"
            style="width:315px;margin-top:10px;"
            class="d-inline-block body-2 ml-0 mr-0 pl-0 pr-0"
            outlined
          ></v-select>
          <div v-if="payload.cert_duration_type">
            <v-col v-if="payload.cert_duration_type === 'etc'" style="padding: 13px 0 0 0;">
              <v-menu
                v-model="startMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    outlined
                    v-model="startDate"
                    readonly
                    v-on="on"
                    dense
                    :style="textFileSize"
                    class="d-inline-block mr-1"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="startMenu = false"
                  locale="ko"
                  :max="endDate"
                ></v-date-picker>
              </v-menu>~
              <v-menu
                v-model="endMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    outlined
                    v-model="endDate"
                    readonly
                    v-on="on"
                    dense
                    :style="textFileSize"
                    class="d-inline-block mr-1"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="endMenu = false"
                  locale="ko"
                  :min="startDate"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col class="pl-0 pt-0 pb-0" v-else>
              <v-col
                class="d-inline-block col-auto mr-auto mr-0 ml-0 pl-0 pt-0 pr-0"
                :style="textFileSize"
              >
                <v-text-field
                  v-model="durationDays.day"
                  class="durationCountText"
                  outlined
                  dense
                  height="50px"
                  type="number"
                  max="9999"
                  min="1"
                  @keydown="M.checkNumber($event)"
                  @keyup="M.replaceDateCount($event, durationDays.type)"
                  @blur="M.replaceDateCount($event, durationDays.type)"
                  :style="textFileSize"
                ></v-text-field>
              </v-col>

              <v-col class="d-inline-block" :style="selectSize">
                <v-select
                  v-model="durationDays.type"
                  :items="items"
                  class="d-inline-block ml-0"
                  :style="selectSize"
                  outlined
                  dense
                  height="50px"
                ></v-select>
              </v-col>
              <div class="mb-0 subtitle-1 font-weight-bold d-inline-block">
                <font class="font-weight-bold body-2 black--text text-truncate">까지</font>
              </div>
            </v-col>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="unAuthDaysDialog = false">닫기</v-btn>
          <v-btn color="blue darken-1" text @click.prevent="execSend">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<style scoped>
.durationCountText >>> input {
  text-align: left;
}
</style>
<script>
import { AUTH_SERVICE } from "@/datas/authservice";
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      M,
      prd: null,
      unAuthDaysDialog: false,
      authDateKind: [
        {
          text: "선택해주세요",
          value: ""
        },
        {
          text: "정품 인증일 기준",
          value: AUTH_SERVICE.ACTIVATED
        },
        {
          text: "코드 생성일 기준",
          value: AUTH_SERVICE.CREATED
        },
        {
          text: "개별 기간 입력 기준",
          value: "etc"
        }
      ],
      items: [
        {
          text: "일",
          value: "d"
        },
        {
          text: "개월",
          value: "m"
        },
        {
          text: "년",
          value: "y"
        }
      ],
      payload: {
        cert_duration_type: AUTH_SERVICE.ACTIVATED,
        cert_duration: ""
      },
      durationDays: {
        day: "",
        type: "d"
      },
      textFileSize: {
        height: "50px",
        width: "110px"
      },
      selectSize: {
        height: "50px",
        width: "130px"
      },
      startMenu: false,
      endMenu: false,
      startDate: "",
      endDate: ""
    };
  },
  mixins: [CommonMixin],
  methods: {
    warrantyPeriodClick: function(data) {
      this.startMenu = false;
      this.endMenu = false;
      this.startDate = "";
      this.endDate = "";
      this.prd = data;
      this.payload.cert_duration_type = "";
      this.durationDays.day = data.cert_duration.replace(/[a-z]/gi, "");
      this.durationDays.type = data.cert_duration.replace(/[0-9]/g, "");
      if (data.cert_validated_at !== null) {
        this.startDate = data.cert_validated_at.substr(0, 10);
        this.endDate = data.cert_expired_at.substr(0, 10);
      }
      this.unAuthDaysDialog = true;
    },
    execSend: function() {
      if (this.payload.cert_duration_type === "") {
        this.alertShow("보증기간 기준을 선택하세요.");
        return false;
      }
      if (this.payload.cert_duration_type === "etc") {
        this.changeDate();
      } else {
        this.changeDuration();
      }
    },
    /**
     * 보증기간 타입변경
     */
    changeDuration: async function() {
      if (this.durationDays.day === "") {
        this.alertShow("보증기간을 입력하세요.");
        return false;
      }
      this.payload.cert_duration = `${this.durationDays.day}${this.durationDays.type}`;

      await M.api(
        M.entry("/serials/duration", this.prd.serial_number),
        this.payload
      );
      this.unAuthDaysDialog = false;
      this.alertShow("정상적으로 보증기간이 변경되었습니다.");
      this.eventHub.$emit("execSearch", false);
    },
    /**
     * 개별 기간 변경
     */
    changeDate: async function() {
      if (this.startDate === "" || this.endDate === "") {
        this.alertShow("보증기간을 입력해주세요.");
        return false;
      }
      let payload = {
        cert_validated_at: this.startDate + " 00:00:01",
        cert_expired_at: this.endDate + " 23:59:59"
      };

      try {
        await M.api(M.entry("/serials/range", this.prd.serial_number), payload);
        this.unAuthDaysDialog = false;
        this.alertShow("정상적으로 보증기간이 변경되었습니다.");
        this.eventHub.$emit("execSearch", false);
      } catch (e) {
        if (e.response.status === 400) {
          this.alertShow("인증된 상품은 보증기간을 변경할수 없습니다.");
        }
      }
    }
  }
};
</script>
